import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import Header from "./components/header";
import HomeSection from "./components/home";
import AboutSection from "./components/about";
import TachSection from "./components/techstack";
import ProductSection from "./components/products";
import ServicesSection from "./components/services";
import FooterSection from "./components/footer";
import Chatpopup from "./components/chatpopup";
import "animate.css";
import Snowfall from "react-snowfall"; // Import Snowfall
import SEO from "./components/SEO";
import Bott from "./assets/images/bott.png"
import "./assets/styles/chat.css";


function App() {
  const [activeLink, setActiveLink] = useState("home");
  const [showChat, setShowChat] = useState(false);

  const toggleChat = () => setShowChat((prev) => !prev);

  // Home Section
  const { ref: homeRef, inView: homeInView } = useInView({
    threshold: 0.1,
    onChange: (inView) => {
      if (inView) setActiveLink("home");
    },
  });

  // About Section
  const { ref: aboutRef, inView: aboutInView } = useInView({
    threshold: 0.5,
    onChange: (inView) => {
      if (inView) setActiveLink("about");
    },
  });

  // Techstack Section
  const { ref: techstackRef, inView: techstackInView } = useInView({
    threshold: 0.5,
    onChange: (inView) => {
      if (inView) setActiveLink("techstack");
    },
  });

  // Products Section
  const { ref: productsRef, inView: productsInView } = useInView({
    threshold: 0.5,
    onChange: (inView) => {
      if (inView) setActiveLink("products");
    },
  });

  // Services Section
  const { ref: servicesRef, inView: servicesInView } = useInView({
    threshold: 0.5,
    onChange: (inView) => {
      if (inView) setActiveLink("services");
    },
  });

  // Footer Section
  const { ref: footerRef, inView: footerInView } = useInView({
    threshold: 0.5,
    onChange: (inView) => {
      if (inView) setActiveLink("footer");
    },
  });

  // Detect when the user scrolls to the very top of the page
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setActiveLink("home");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <img
  src={Bott}
  alt="Bot Icon"
  onClick={() => setShowChat(true)}
  className="fixed z-2"
  style={{
    bottom: '50px',
    right: '40px',
    width: '70px',         // You can adjust to '70px' or '60px'
    height: '70px',
    position: 'fixed',
    cursor:'pointer',
    pointerEvents: 'auto',
  }}
/>
{/* Chat Popup - Appears at bot image position */}
{showChat && (
        <div
    
          className="chat-popup fixed z-2  shadow-lg rounded-lg"
          style={{
            bottom: "30px",
            right: "20px",
            width: "380px",
            height: "490px",
            position: "fixed",
            borderRadius: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
          }}
        >
          <Chatpopup onClose={toggleChat} />
        </div>
      )}
      {/* Add Snowfall Effect
      <Snowfall
        color="white"
        snowflakeCount={100} // Number of snowflakes
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1, // Adjust z-index to ensure visibility
        }}
      /> */}

      <SEO />

      <Header activeLink={activeLink} setActiveLink={setActiveLink} />

      {/* Attach refs to actual DOM elements */}
      <section ref={homeRef} id="home">
        <HomeSection />
      </section>
      <section ref={servicesRef} id="services">
        <ServicesSection />
      </section>
      <section ref={aboutRef} id="about">
        <AboutSection />
      </section>
      <section ref={techstackRef} id="techstack">
        <TachSection />
      </section>
      <section ref={productsRef} id="products">
        <ProductSection />
      </section>
      <section ref={footerRef} id="footer">
        <FooterSection />
      </section>
    </div>
  );
}

export default App;
